import { Component, OnInit, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from '../services/settings.service';
import { Ip } from '../settings/settings.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-ips',
  templateUrl: './ips.component.html',
  styleUrls: ['./ips.component.css']
})
export class IpsComponent implements OnInit {
  id:number;
  ip:string;
  constructor(public dialogRef: MatDialogRef<IpsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Ip,private settingService:SettingsService) { 
    this.ip = settingService.getip();
    this.id = settingService.getIpId();
  }


  ngOnInit() {
  }

  closeModal() {
    this.dialogRef.close();
  }

}
